module.exports = __webpack_public_path__ + "img/plans2.9e926405.jpg";